// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const swatch: Styleguide["swatch"] = {
    borderType: "round",
    borderRadius: {
        round: "50%",
        square: "0%",
        roundedSquare: "25%",
    },
};

export default swatch;
